import React from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import 'assets/scss/soonoGetStarted.css';
import { getSelectedPlan } from '../../constants/localStorageManager';
import { PLANS } from '../../constants/plans';

const StepIndicator = ({
  step,
  currentStep,
  stepName,
  link,
  currentStepNumber,
  activeStepNumber,
}) => {
  const isCurrentStep = step === currentStep;
  const isCompleted = currentStepNumber < activeStepNumber;
  const selectedPlan = getSelectedPlan() || {};
  const isTrialSelected = selectedPlan.plan_name === PLANS.FREE;
  const hidePlanDetails = isTrialSelected || !selectedPlan.plan_name;

  if (step === TRIAL_SIGNUP_ROUTES.PAYMENT_DETAILS && hidePlanDetails)
    return null;
  return (
    <div>
      <li>
        <div
          class={`node ${
            isCurrentStep || isCompleted ? 'active-menu-node' : null
          }`}
        >
          {isCompleted && (
            <FontAwesomeIcon icon="check" className="text-white steps-icon" />
          )}
        </div>
        <NavLink
          onClick={e => {
            e.preventDefault();
          }}
          className="text"
          isActive={() => isCurrentStep || isCompleted}
          exact
          activeClassName="active-menu"
          to={link}
        >
          {stepName}
        </NavLink>
      </li>
      <li>
        <div class="divider"></div>
      </li>
    </div>
  );
};

export default StepIndicator;



// WEBPACK FOOTER //
// ./src/components/transactions/StepsIndicator.js